module.exports = __webpack_public_path__ + "media/images/lb/903-74c31227b48acfd6e0574f88cde06517.svg";